import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import LoginComponent from '@shared-features/login/login.component';
import { SubIdSelectorComponent } from '@shared-features/sub-id-selector/sub-id-selector.component';
import { isAuthenticatedGuard } from 'projects/shared/src/lib/auth/guards/auth.guard';
import { adminGuard } from 'projects/shared/src/lib/features/header/guards/admin.guard';
import { HomeComponent } from './features/home/home.component';
import { PromptTestingComponent } from './features/prompt-testing/prompt-testing.component';
import { DashboardComponent } from "./features/dashboard/dashboard.component";
import { ContractComponent } from "./features/contract/contract.component";
import { AdministrationComponent } from "./features/administration/administration.component";

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'contract/:id',
    component: ContractComponent,
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'testing',
    component: PromptTestingComponent,
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'selector',
    component: SubIdSelectorComponent,
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'administration',
    component: AdministrationComponent,
    canActivate: [isAuthenticatedGuard, adminGuard],
  },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
